// 실물카드 인쇄 — 칸별 개별 위치 보정값(mm) 정규화 헬퍼.
// 최종 인쇄 위치 = 일괄 보정(7칸 전체 이동) + 칸별 개별 보정(이 파일이 다루는 값). 두 값은 합산된다.
// 값은 운영자 PC localStorage에 저장되므로 손상·구버전 형식이 들어와도 항상 7칸 {x,y} 숫자로 돌려준다.

// 입력칸 min/max와 같은 한계(mm). 일괄 보정과 같은 범위.
export const FIELD_OFFSET_LIMIT_MM = 5;

const clamp = (n) => Math.min(FIELD_OFFSET_LIMIT_MM, Math.max(-FIELD_OFFSET_LIMIT_MM, n));
const toMm = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? clamp(n) : 0;
};

export function emptyFieldOffsets(keys) {
  return Object.fromEntries(keys.map((key) => [key, { x: 0, y: 0 }]));
}

// 저장값(raw)을 keys 기준 7칸 {x,y}로 맞춘다 — 모르는 칸은 버리고, 없는 칸·숫자 아닌 값은 0.
export function normalizeFieldOffsets(raw, keys) {
  const src = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  return Object.fromEntries(keys.map((key) => {
    const o = src[key] && typeof src[key] === 'object' ? src[key] : {};
    return [key, { x: toMm(o.x), y: toMm(o.y) }];
  }));
}
